import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Pagination, PaginationHolder} from '@app/core/models/pagination.model';
import {Card} from '@app/core/models/card.model';
import {DepartmentSubscription, Invoice, Product} from '@app/core/models/subscription.model';
import {HttpService} from '@app/core/services/http.service';
import {map} from 'rxjs/operators';
import {IHostedInvoiceLinkModel} from '@app/core/models/hosted-invoice-link.model';
import {environment} from '@env/environment';

@Injectable({
	providedIn: 'root',
})
export class SubscriptionService {

	constructor(
		private http: HttpService,
	) {
	}

	public getProducts(): Observable<PaginationHolder<Product>> {
		return this.http.getJson<PaginationHolder<Product>>('payment/products');
	}

	public getInvoices(department_id: number, page: number, pageSize: number): Observable<PaginationHolder<Invoice>> {
		return this.http.getJson<PaginationHolder<Invoice>>('payment/invoices', {
			department_id,
			page,
			page_size: pageSize,
		}).pipe(map((res: PaginationHolder<Invoice>) => {
			res.pagination = new Pagination().deserialize(res.pagination);
			res.data = res.data.map(invoice => ({
				...invoice,
				hosted_page_url: 'open-hosted-invoice?id=' + invoice.id,
			}));

			return res;
		}));
	}

	public getSubscriptions(department_id: number): Observable<PaginationHolder<DepartmentSubscription>> {
		return this.http.getJson<PaginationHolder<DepartmentSubscription>>('payment/subscriptions', {department_id});
	}

	public subscribeToPlan(department_id: number, product_id: number, plan_id: number): Observable<DepartmentSubscription> {
		return this.http.postJson<DepartmentSubscription>(
			'payment/subscriptions',
			{
				department_id,
				product_id,
				plan_id,
			},
		);
	}

	public unsubscribeToPlan(subscription: DepartmentSubscription): Observable<DepartmentSubscription> {
		return this.http.deleteJson<DepartmentSubscription>('payment/subscriptions/' + subscription.id);
	}

	public getCard(department_id: number): Observable<Card> {
		const body = {
			department_id,
		};

		return this.http.getJson<Card>('payment/paymentMethod');
	}

	public postCard(department_id: number, token: string): Observable<Card> {
		const body = {
			token,
			default: true,
			department_id,
		};

		return this.http.postJson<Card>('payment/paymentMethod', body);
	}

	public getHostedInvoice(id: number): Observable<IHostedInvoiceLinkModel> {
		return this.http.getExternalUrlJson<IHostedInvoiceLinkModel>(`${environment.baseApiUrl}invoices/${id}/link`);
	}
}
